import React from "react";
import Storage from "../../services/storage.service";
import Settings from "../../services/settings.service";
import Translations from "../../services/translation.service";
import DownloadAppLinks from '../../views/shared/stf_download_links.component';
import AbsherLockImg from "../../assets/img/Absher_lock.png";
import Helpers from "../../helpers/shared.helper";

export default function SimDeactivationAbsher(props) {
    let prefix = 'scr_3.4.2_A_Absher_';

	const redirectToAbsher = () => {
        let business = JSON.parse(Storage.get("business", true));
		let callbackUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '#/sim-deactivation/absher';
		window.location.href = business[Settings?.absher_login_url || "absher_login_url"] + '?channel=web&callback=' + callbackUrl;
    }

    const getAbhserText = (absherText) => {
		const brokenText = absherText?.split('\n\n');
		return brokenText?.map((item, index) => {
			return <p key={index}>{item}</p>;
		});
	}

	return (<div className="stf-absher-container">
        <img src={AbsherLockImg} alt="" />
        <img src={Helpers.getPOImageCommon("nafath_logo", "nafath_logo", Translations.activeLang) || ""} alt="" className="nafath-img"/>
        <div className="absher-content-container">
            <span className="absher-content">
                {getAbhserText(Translations.keys[prefix + "breif"])}
            </span>
            <button
                className="common-button"
                onClick={() => {
                    redirectToAbsher();
                }}
            >
                {Translations.keys[prefix + "breif_btn_label"]}
            </button>
        </div>
        <div className="stf-download-app-container">
            <div className="absher-download">
                {Translations.keys["scr_3.3.3_app_download_info"]}
            </div>
            <DownloadAppLinks
                classes={"stf-download-btns-area"}
                google_play_link={Settings.google_play_link}
                app_store_link={Settings.app_store_link}
                huawei_store_link={Settings.huawei_store_link}
            />
        </div>
    </div>)
}